import { InboxMessageOrigin } from 'lib/enum/inbox-message-origin.enum';

const isSentBySystem = (origin: InboxMessageOrigin): boolean => {
    switch (origin) {
        case InboxMessageOrigin.BirdFlow:
        case InboxMessageOrigin.ConversationalAgent:
        case InboxMessageOrigin.JourneyAutomation: {
            return true;
        }
        default: {
            return false;
        }
    }
};

const isSentByConversationalAgent = (origin: InboxMessageOrigin): boolean =>
    origin === InboxMessageOrigin.ConversationalAgent;

const InboxMessageUtils = {
    isSentByConversationalAgent,
    isSentBySystem,
};

export default InboxMessageUtils;
